module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921125334_T.6286bfae.jpg";